<template>
  <section class="c-pt-6 c-sm:c-pt-7 c-xl:c-pt-8 overflow-hidden">
    <div class="container c-lg:overflow-hidden">
      <h2 class="c-mb-4 c-md:c-mb-5 c-xl:c-mb-7 text-center">
        {{ t('read_more') }}
      </h2>
      <div class="row no-gutters ml-n2 c-sm:ml-n4 c-md:ml-n5 c-xl:ml-n6 c-mb-0">
        <ul
          class="media-other_catalog row c-mx-0 c-w-100 c-mb-0 c-flex-nowrap c-flex-grow-1 c-h-auto no-gutters c-mb-0 list-unstyled c-justify-center"
          data-carousel="media"
        >
          <li
            v-for="medium in media"
            :key="medium.id"
            class="flex c-flex-col col-6 c-md:col-5 c-lg:col-3"
          >
            <div class="c-pl-2 c-sm:c-pl-4 c-md:c-pl-5 c-xl:c-pl-6 flex c-flex-col c-flex-grow-1">
              <div class="product-item c-p-3 c-md:c-p-4 c-m-0 relative c-flex-grow-1">
                <RemoteResponsiveImage
                  v-if="medium.image"
                  :product-image-data="medium.image"
                  img-class="media-other_catalog-img"
                  :alt="medium.source"
                  sizes="(min-width: 1200px) 25vw, (min-width: 600px) 30vw, (min-width: 500px) 30vw, 50vw"
                />
                <RemoteImage
                  v-else
                  img-class="media-other_catalog-img"
                  :alt="medium.source"
                />
                <div class="c-pt-2 mb-n1 text-center text-lg-c medium-source">
                  <router-link
                    :to="{ name: 'mediaDetailPath', params: { permalink: medium.permalink } }"
                    class="product-item__title block stretched-link !no-underline font-medium"
                  >
                    {{ medium.source }}
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- ShowAll -->
      <div class="c-mt-5 c-lg:c-mt-6 text-center">
        <router-link
          :to="{ name: 'mediaPath' }"
          class="btn btn-success c-px-6 c-py-3  c-rounded-pill font-medium"
        >
          {{ t('show_all') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'

const { t } = useI18n()
defineProps({
  media: {
    type: Array,
    required: true,
  },
})
</script>

<style lang="scss">
@include media-breakpoint-up(c-lg) {
	.overflow-lg-hidden { overflow: hidden !important; }
}
.media-other_catalog {
  &-img {
    width: 225px;
    height: 300px;
    object-fit: cover;
    object-position: top;
  }
}

@media (max-width: 1200px) {
  .media-other_catalog {
    &-img {
      width: 174px;
      height: 232px;
    }
  }
}

@media (max-width: 992px) {
  .media-other_catalog {
    &-img {
      width: 234px;
      height: 312px;
    }
  }
}

@media (max-width: 768px) {
  .media-other_catalog {
    &-img {
      width: 219px;
      height: 292px;
    }
  }
}

@media (max-width: 576px) {
  .media-other_catalog {
    &-img {
      width: 100%;
      height: 230px;
    }

    .medium-source {
      max-height: 60px;
      overflow: hidden;
    }
  }
}
</style>

<i18n>
  {
    "cs": {
    "read_more": "Číst další",
    "show_all": "Zobrazit všechny"
},
    "sk": {
    "read_more": "Čítať ďalšie",
    "show_all": "Zobraziť všetky"
},
    "pl": {
    "read_more": "Przeczytaj więcej",
    "show_all": "Zobacz wszystkie"
},
    "hu": {
    "read_more": "Mutass többet",
    "show_all": "Mutass mindent"
},
    "de": {
    "read_more": "Mehr lesen",
    "show_all": "Alle anzeigen"
},
    "at": {
    "read_more": "Mehr lesen",
    "show_all": "Alle anzeigen"
},
    "ro": {
    "read_more": "Citesc mai departe",
    "show_all": "Arată totul"
},
    "fr": {
    "read_more": "En savoir plus",
    "show_all": "Afficher tout"
},
    "it": {
    "read_more": "Leggi altro",
    "show_all": "Mostra tutto"
}
  }
</i18n>
